import { Component, ViewChild, ElementRef, Input, Output, EventEmitter, forwardRef, OnInit, AfterViewInit, SimpleChanges } from '@angular/core';
import { Observable, of, Observer } from 'rxjs';
import { TypeaheadMatch, TypeaheadDirective } from 'ngx-bootstrap/typeahead';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FilterPipe } from '../../../helpers/filter.pipe';
import { OrDropdownOption } from '../../../models/or-dropdown';
import { ProjectTeam } from '../../../models/project';

@Component({
    selector: 'or-multi-tag-dropdown',
    templateUrl: './multi-tag-dropdown.component.html',
    styleUrls: ['./multi-tag-dropdown.component.scss'],
    standalone: false
})


export class MultiTagDropdownComponent implements OnInit {


  private _selectedValues: OrDropdownOption[] = [];
  private _dropdownOptions: OrDropdownOption[] = [];

  @Input()
  get selectedValues(): OrDropdownOption[] {
    return this._selectedValues;
  }
  set selectedValues(values: OrDropdownOption[]) {
    this._selectedValues = values || [];
    this.updateDropdownState();
  }

  @Input()
  get dropdownOptions(): OrDropdownOption[] {
    return this._dropdownOptions;
  }
  set dropdownOptions(options: OrDropdownOption[]) {
    this._dropdownOptions = options || [];
    this.updateDropdownState();
  }

  private updateDropdownState(): void {
    this.noOptionAvailable = this._dropdownOptions.length === this._selectedValues.length;
    this.ddUnselectedOptions = this._dropdownOptions.filter(
      option => !this._selectedValues.some(selected => selected.value === option.value)
    );
  }

  @Input() placeholderForDropdown = 'Search and select user';
  @Input() labelForAddition = 'Add User';
  @Input() width: string;
  @Input() class: string = '';
  @Output() valueAdded = new EventEmitter<OrDropdownOption>();
  @Output() valueAfterRemove = new EventEmitter<OrDropdownOption>();

  dropdownSelectedValue: string = null;
  addingNew: boolean = false;
  noOptionAvailable: boolean = false;
  ddUnselectedOptions: OrDropdownOption[] = [];

  constructor() { }


  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dropdownOptions']) {
      // console.log('Dropdown values updated:', changes['dropdownOptions'].currentValue);
    }
  }

  addTag(value: OrDropdownOption) {
    this.valueAdded.emit(value);
    this.addingNew = false;
  }


  removeTag(tag: OrDropdownOption) {
    this.valueAfterRemove.emit(tag);
  }


  triggerAddNew() {
    if(!this.noOptionAvailable) {
      this.addingNew = true;
    }
  }

}

